import type { AmountType } from '@/types/interfaces'

export const Currencies = { CNY: '¥', USD: '$' }
export const CurrenciesInNumber = { 1: '$', 2: '￥' }

export const DefaultCurrency: AmountType = 'USD'
